import { useEffect } from 'react';
import { fetchJsonWithAuth } from '../../../shared/fetch-json.util';
import { getEnvVar } from '../../../utils/getEnvVar';

export default function GetSDIMasterList(props) {
  const {
    tokenAvailable,
    setStatusErrorMsg,
    incrementAPIInProgress,
    decrementAPIInProgress
  } = props.commonProps;
  const { setSdiMasterList } = props;

  const fillSDIMasterList = () => {
    const api = getEnvVar('VITE_SDI_MASTER_API_URL');

    incrementAPIInProgress();
    fetchJsonWithAuth(api)
      .then((response) => {
        const sdiList = response.json.types.map((sdiObj) => sdiObj.shortName);

        sdiList.sort();

        setSdiMasterList(sdiList);
      })
      .catch((error) =>
        setStatusErrorMsg(
          "Couldn't retrieve SDI Master List. Please try again.",
          error
        )
      )
      .finally(() => decrementAPIInProgress());
  };

  useEffect(() => {
    if (tokenAvailable) fillSDIMasterList();
  }, [tokenAvailable]);

  return <></>;
}
